<template>
	<div>
		<v-text-field
			browser-autocomplete="off"
			label="Label pola"
			aria-label="label"
			for="conditional-field-props-label"
			id="conditional-field-props-label"
			v-model="fieldProps.label"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-text-field
			browser-autocomplete="off"
			label="Hint"
			aria-label="hint"
			for="conditional-field-props-hint"
			id="conditional-field-props-hint"
			v-model="fieldProps.hint"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-text-field
			browser-autocomplete="off"
			label="Tekst - Tak"
			aria-label="yes case text"
			for="conditional-field-props-text-yes"
			id="conditional-field-props-text-yes"
			v-model="fieldProps.textOn"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-text-field
			browser-autocomplete="off"
			label="Tekst - Nie"
			aria-label="no case text"
			for="conditional-field-props-text-no"
			id="conditional-field-props-text-no"
			v-model="fieldProps.textOff"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-text-field
			browser-autocomplete="off"
			v-if="!edit"
			label="Nazwa grupy - Tak"
			aria-label="group yes case"
			for="conditional-field-props-group-name-yes"
			id="conditional-field-props-group-name-yes"
			v-model="fieldProps.groupOn"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-text-field
			browser-autocomplete="off"
			v-if="!edit"
			label="Nazwa grupy - Nie"
			aria-label="group no case"
			for="conditional-field-props-group-name-no"
			id="conditional-field-props-group-name-no"
			v-model="fieldProps.groupOff"
			class="text-xs-center"
			outline>
		</v-text-field>
	</div>
</template>

<script>
	export default {
		name: "conditionalFieldProps",

		data() {
			return {
				fieldProps: this.value,
			};
		},

		props: {
			value: Object,
			edit: {
				type: Boolean,
			},
		},

		watch: {
			fieldProps: {
				handler() {
					this.$emit("input", this.fieldProps);
				},
				deep: true,
			},
		},
	};
</script>

<style scoped>

</style>
